export class MetaData {
  constructor(
    public title: string,
    public description: string = '',
    public image: string = '',
    public scalable: boolean = false
  ) {}
}
